import styled from 'styled-components';

export const Badge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;

  &.priority-alta {
    background: ${(props) => props.theme.$danger};
    color: ${(props) => props.theme.$white};
  }
  &.priority-media {
    background: ${(props) => props.theme.$warning};
    color: ${(props) => props.theme.$gray900};
  }
  &.priority-baixa {
    background: ${(props) => props.theme.$info};
    color: ${(props) => props.theme.$white};
  }
`;
